import { useContext } from 'react';

// eslint-disable-next-line import/no-cycle -- TODO: pre-existing cycle via DataModelContext, fix when context is restructured
import { PageTypeSettingsContext } from 'contexts/page-type-settings/PageTypeSettingsContext';

export const usePageTypeSettingsContext = () => {
  const pageTypeSettingsState = useContext(PageTypeSettingsContext);
  return pageTypeSettingsState;
};
